module.exports = __webpack_public_path__ + "img/completed-icon.1a7ddb3e.svg";